'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { Record } from 'immutable';
import get from 'transmute/get';
import UserProfile from './UserProfile';
var defaults = {
  userProfile: new UserProfile(),
  portalId: null,
  userId: null,
  isSalesStarter: false,
  calendarProvider: null
};

var PublicMeetingsUser = /*#__PURE__*/function (_Record) {
  _inherits(PublicMeetingsUser, _Record);

  function PublicMeetingsUser() {
    _classCallCheck(this, PublicMeetingsUser);

    return _possibleConstructorReturn(this, _getPrototypeOf(PublicMeetingsUser).apply(this, arguments));
  }

  _createClass(PublicMeetingsUser, null, [{
    key: "from",
    value: function from(json) {
      return new PublicMeetingsUser(Object.assign({}, json, {
        isSalesStarter: json.hasSalesStarterFeatures || json.isSalesStarter || json.salesPro || false,
        userProfile: new UserProfile(json.userProfile)
      }));
    }
  }, {
    key: "fromBookInfo",
    value: function fromBookInfo(bookInfo) {
      return get('meetingsUser', bookInfo.allUsersBusyTimes.find(function (userBusyTimes) {
        return userBusyTimes.meetingsUser.userId === bookInfo.userId;
      }));
    }
  }]);

  return PublicMeetingsUser;
}(Record(defaults));

export { PublicMeetingsUser as default };